export const CaseDifficulty = {
  easy: "Easy",
  medium: "Medium",
  hard: "Hard",
};

export const CaseMasterScreens = {
  HOME: 'HOME',
  TOPICS: 'TOPICS',
  CHALLENGES: 'CHALLENGES',
  PERSONALIZED: 'PERSONALIZED'
}

export const AttemptStates = {
  FEEDBACK_GENERATED: 'feedback_generated',
  FEEDBACK_SKIPPED: 'feedback_skipped',
  NOT_APPLICABLE: 'not_applicable'
};

export const AssessmentEntryPoint = {
  PERSONALIZED: 'personalized',
  GENERAL_CASE_STUDY: 'general_case_study',
  CONTEST: 'contest',
  MOCK: 'mock'
}
